import type { ReactNode } from 'react';

export const symbol_mail_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M397-477Zm166-6Zm202 373-51-50H140q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h20l60 60h-80v520h514L76-798q-9-9.07-9-21.53Q67-832 76.05-841q9.06-9 21.5-9 12.45 0 21.45 9l689 689q9 9 9 21t-9.05 21q-9.06 9-21.5 9-12.45 0-21.45-9Zm115-630v502q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-447L560-514q-11 7-20.42 3.66-9.43-3.34-14.5-11.5Q520-530 521-539.5t12-16.5l283-184H318q-15 0-22.5-9.32t-7.5-20.5q0-11.18 7.5-20.68T318-800h502q24 0 42 18t18 42Z"
		/>
	</svg>
);
